export const keys = {
  user: 'USER_PROXY_KEY',
  token: 'TOKEN_PROXY_KEY',
  refreshToken: 'REFRESH_TOKEN_PROXY_KEY',
  theme: 'THEME_KEY',
};
